import { render, staticRenderFns } from "./comboStatistics.vue?vue&type=template&id=f05f1b46&scoped=true&"
import script from "./comboStatistics.vue?vue&type=script&lang=js&"
export * from "./comboStatistics.vue?vue&type=script&lang=js&"
import style0 from "./comboStatistics.vue?vue&type=style&index=0&id=f05f1b46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05f1b46",
  null
  
)

export default component.exports